import { qs ,qsArray } from './utilities/selectors';
import Intro from "./intro";
import Controls from "./controls";
import Question from "./question";
import Results from "./results";
import ProgressBar from "./progress-bar";
import testHistory from './test/history';
import { totalmem } from 'os';

let BallSelector = function () {
  if (BallSelector.prototype._singletonInstance) {
    return BallSelector.prototype._singletonInstance;
  }
  BallSelector.prototype._singletonInstance = this;

  this.initialize();
};

BallSelector.prototype.initialize = function () {
  console.log('BallSelector initalizing');


  function handleBackButton() {
    results.hide();
    // hide and reset where we currently are
    controls.disable();
    currentQuestion.hide(function () {
      currentQuestion.reset();

      if (history.length > 0) {
        // return to the last question
        progressBar.show();
        currentQuestion = history.pop();
        progressBar.setProgress(history.length, totalQuestions);
        // we can make an assumption that next button should be active when returning to a previous question
        controls.enableNextButton();
        currentQuestion.show(function () {
          controls.enable();
          console.log('history', JSON.parse(JSON.stringify(history)));
        });
      } else {
        progressBar.setProgress(0, totalQuestions);
        progressBar.hide();
        controls.disableNextButton();
        controls.disableBackButton();
        intro.show();
      }
    });
  }


  // vars/
  let history = [];
  let questions = {};
  let startQuestionId = 'question-1';
  let currentQuestion = null;
  let shortcut = null;
  let totalQuestions = 11;
  // let controlsEl = document.getElementById('controls');
  let controls = new Controls();
  let intro = new Intro({
    el: document.getElementById('intro'),
    cb: startQuestions
  });
  let results = new Results({
    el: document.getElementById('results'),
    restart: restart,
    goBack: handleBackButton
  });
  let progressBar = new ProgressBar();

  // initialize each question
  qsArray('.question').forEach(function(el){
    let id = el.getAttribute('id');
    questions[id] = new Question({
      id: id,
      el: el
    });
  });
  // assign currentQuestion to the first question
  currentQuestion = questions[startQuestionId];

  // Initialize global control events
  controls.onBackButtonClick = handleBackButton;

  function restart() {
    results.hide(function () {
      // loop through history and reset each question
      while (history.length) {
        let q = history.pop();
        q.reset();
      }

      // assign currentQuestion to the first question
      currentQuestion = questions[startQuestionId];
      totalQuestions = 11;
      progressBar.setProgress(0, totalQuestions);

      intro.show();
    });
  }



  controls.onNextButtonClick = function() {
    // console.log('Next Button Clicked');

    controls.disable();

    // call Question.getNext()
    // push currentQuestion into history
    // hide currentQuestion
    // show next Question or Results based on what getDataNext returns
    let next = currentQuestion.getNext();
    if (currentQuestion.id === 'question-1') {
      shortcut = currentQuestion.getShortcut();
    }
    history.push(currentQuestion);


    // console.log('Next:', next);
    // console.log('Shortcut:', shortcut);
    console.log('history', JSON.parse(JSON.stringify(history)));

    if (next === 'results') {
      progressBar.setProgress(totalQuestions, totalQuestions);
    } else {
      try {
        if (next.includes('plus')) {
          totalQuestions = 11;
        } else if (next.includes('performance')) {
          totalQuestions = 10;
          if (shortcut != null) {
            totalQuestions = 9;
          }
        } else if (next.includes('preference')) {
          totalQuestions = 7;
        }
        // console.log('next question is ' + next + ' total is ' + totalQuestions);
      } catch (e) {
        totalQuestions = 11;
      }
      progressBar.setProgress(history.length, totalQuestions);
    }

    currentQuestion.hide(function () {
      // Check if next is question-3 and shortcut is not null
      if (next === 'question-3' && shortcut !== null) {
        next = shortcut;
      }
      // Check if next is results
      if (next === 'results') {
        controls.disableBackButton();
        controls.disableNextButton();
        // use this to capture history for easy testing
        //console.log('RESULTS');
        //console.log(JSON.stringify(history));
        results.show(history);
        progressBar.hide();
      } else {
        currentQuestion = questions[next];
        if (currentQuestion.getInputType() !== 'slider') {
          controls.disableNextButton();
        }
        currentQuestion.show(function () {
          controls.enable();
        });
        
      }

      if (history.length > 0) {
        controls.enableBackButton();
      }
    });

  }

  function startQuestions () {
    intro.hide(function () {
      progressBar.show();
      currentQuestion.show(function () {
        controls.enable();
        controls.enableBackButton();
      });
    });
  }

  // public methods
  this.getHeight = function () {
    let height = 800;
    let width = window.innerWidth;
    let body = document.body;
    let main = document.getElementById('main');

    height = main.clientHeight;
      //Math.max(body.scrollHeight, body.offsetHeight,
      //html.clientHeight, html.scrollHeight, html.offsetHeight);
    //console.log('Heres the HEIGHT: ' + height);

    // Calc height based on window size and currentState:
    // preloader, intro, question, results
    /*if (width < 800) {
      height = 668;
      if (results.getIsActive()) {
        height = 1000;
        if (results.getIsExpanded()) {
          height = 1600;
        }
      }
    } else {
      if (results.getIsActive()) {
        height = 1000;
        if (results.getIsExpanded()) {
          height = 1200;
        }
      }
    }
    */
    return height;
  }

  // start the app
  intro.showInstant();

  // // jump to specific question
  // startQuestionId = 'question-1';
  // startQuestionId = 'question-2';
  // startQuestionId = 'question-3';
  // startQuestionId = 'performance-q2';
  // startQuestionId = 'performance-q3';
  // startQuestionId = 'performance-q4';
  // startQuestionId = 'performance-q5';
  // startQuestionId = 'performance-q6';
  // startQuestionId = 'performance-best';
  // startQuestionId = 'performance-q7';
  // startQuestionId = 'plus-q2';
  // startQuestionId = 'plus-q3';
  // startQuestionId = 'plus-q4';
  // startQuestionId = 'plus-q5';
  // startQuestionId = 'plus-q6';
  // startQuestionId = 'plus-best';
  // startQuestionId = 'plus-q7';
  // startQuestionId = 'plus-q8';
  // startQuestionId = 'preference-q1';
  // startQuestionId = 'preference-q2';
  // startQuestionId = 'preference-q3';
  // startQuestionId = 'preference-q4';
  // currentQuestion = questions[startQuestionId];
  // progressBar.show();
  // currentQuestion.show(function () {
  //   controls.enable();
  //   controls.enableBackButton();
  // });

  // debug results
  // results.show(JSON.parse(testHistory['avx-v1']));
  // results.show(JSON.parse(testHistory['velocity-green-trufeel']));
  // results.show(JSON.parse(testHistory['tour-speed-tour-soft-yellow']));
  // results.show(JSON.parse(testHistory['v1x-yellow-v1xld']));
  // results.show(JSON.parse(testHistory['tour-soft-velocity-orange']));
  // results.show(JSON.parse(testHistory['v1xld-v1x-white']));
}

export default BallSelector;
